import { IGeneralRequestResponse } from '@services/httpClientService';

import { transformCartBenefits } from '../../../mapper';
import { IProductsUpdateData } from '../model';

import { IAddProductResponse } from './model';

export const mappingFunction = (result: IAddProductResponse): IGeneralRequestResponse<IProductsUpdateData> => {
  const {
    addProduct: { data },
  } = result;

  return {
    ...result.addProduct,
    data: {
      ...data,
      benefits: transformCartBenefits(data.benefits),
    },
  };
};
